// Document sizes: {{size}} is already formatted for the interface language
// (decimal separator included), so each locale only chooses its units.
const fileSize = {
  fr: { fileSizeBytes: '{{size}} o', fileSizeKilobytes: '{{size}} Ko', fileSizeMegabytes: '{{size}} Mo' },
  en: { fileSizeBytes: '{{size}} B', fileSizeKilobytes: '{{size}} KB', fileSizeMegabytes: '{{size}} MB' },
  es: { fileSizeBytes: '{{size}} B', fileSizeKilobytes: '{{size}} KB', fileSizeMegabytes: '{{size}} MB' },
  pt: { fileSizeBytes: '{{size}} B', fileSizeKilobytes: '{{size}} KB', fileSizeMegabytes: '{{size}} MB' },
  vi: { fileSizeBytes: '{{size}} B', fileSizeKilobytes: '{{size}} KB', fileSizeMegabytes: '{{size}} MB' },
  hi: { fileSizeBytes: '{{size}} B', fileSizeKilobytes: '{{size}} KB', fileSizeMegabytes: '{{size}} MB' },
  ar: { fileSizeBytes: '{{size}} بايت', fileSizeKilobytes: '{{size}} كيلوبايت', fileSizeMegabytes: '{{size}} ميغابايت' },
  ur: { fileSizeBytes: '{{size}} B', fileSizeKilobytes: '{{size}} KB', fileSizeMegabytes: '{{size}} MB' },
};

export default fileSize;
